<template>
  <div>
    <div class="set" v-if="loaded">
      <AppNavbar :placeholder="true" :zIndex="20" title="设置"> </AppNavbar>
      <div class="set-list">
        <div class="set-item" v-for="(item, index) in setShowData" :key="index">
          <span class="item-left">{{ item.title }}</span>
          <van-switch
            v-if="item.loaded"
            v-model="item.allow"
            size="24px"
            @click="toggleCheckbox(item)"
            :loading="item.loading"
            active-color="#6236FF"
          />
        </div>
      </div>
      <div class="tips">若要放弃喝水变美挑战，可在此处关闭喝水提醒</div>
      <div class="time-list" v-if="userInfo && userInfo.list.length">
        <div class="time-title">推荐定时提醒</div>
        <div
          class="time-item"
          v-for="(item, index) in userInfo.list"
          :key="index"
        >
          <div class="item-left">
            <span class="clock iconfont icon-clock-4"></span>
            <span class="time">{{ item.time_slot }}</span>
          </div>
          <!-- 彩虹杯样式 -->
          <div class="item-right">
            <img
              class="water-droplet"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4bbc8519dc3cf5dd7e5261badafe9953.png"
              alt=""
            />
            <div class="ml"> {{ item.water_volume }}ml </div>
          </div>
        </div>
      </div>
      <div class="replace-content">
        <div class="item-left">想要更精准的喝水方案？</div>
        <div class="item-right" @click="bindChangeCup">
          <span>切换为彩虹杯</span>
          <span class="btn iconfont icon-you"></span>
        </div>
      </div>
      <!-- 时间：选择器 -->
      <van-popup v-model="showEdit" position="bottom" round get-container="app">
        <van-datetime-picker
          v-model="curTime"
          type="time"
          title="选择提醒时间"
          :min-hour="6"
          :max-hour="8"
          @confirm="bindConfirm"
          @cancel="bindCancel"
        />
      </van-popup>
      <MyToast
        :options="toastOptions"
        v-model="showToast"
        @confirm="bindConfirm"
      ></MyToast>
      <TutorialTip
        v-model="showTutorial"
        @click="bindNextTip"
        :options="tipsOptions"
      ></TutorialTip>
    </div>
    <AppLoading class="v-loading" v-if="!loaded" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AppLoading from '@/components/app/loading/loading.vue'
import MyToast from '../components/toast.vue'
import TutorialTip from '../components/tutorial.vue'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import { Calendar, switchCalendar } from '../data'
export default {
  name: 'drink-water-reminder-normal-set',
  components: {
    MyToast,
    TutorialTip,
    AppNavbar,
    AppLoading
  },
  data() {
    return {
      setData: [
        {
          title: '允许系统通知',
          id: 'generic_is_open_system',
          setId: 'sys_open',
          loaded: false,
          allow: true,
          loading: false,
          hide: false,
          value: '',
          toggle: 'changeSystemReminder'
        },
        {
          title: '允许日历通知',
          id: 'generic_is_open_calendar',
          setId: 'day_open',
          loaded: false,
          allow: false,
          loading: false,
          hide: false,
          value: '',
          toggle: 'changeCalendarReminder'
        }
      ],
      loaded: false,
      recordId: 0, //喝水记录id
      showEdit: false,
      curTime: '8:00',
      userInfo: null,
      timeList: [{}, {}, {}, {}, {}, {}, {}, {}],
      toastOptions: {
        showCancelButton: true,
        image:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_err_icon_3',
        imageTop: '-80px',
        title: '标题',
        message: '喝水'
      }, //信息弹框的数据参数
      showToast: false,
      showTutorial: false,
      curTutorial: 0,
      tipsOptions: {},
      tipsStepList: [
        {
          id: 'edit',
          top: -10,
          direction: 'top',
          text: '起始时间建议调整为您的起床时间哦～'
        }
      ]
    }
  },
  computed: {
    ...mapState('drinkWater', ['cupType', 'waterId']),
    setShowData() {
      return this.setData.filter((item) => {
        return !item.hide
      })
    }
  },
  watch: {},
  created() {},
  activated() {
    this.init()
  },
  mounted() {
    localStorage.removeItem('calendarId')
  },
  methods: {
    init() {
      this.allowShowCalendar()
      this.getDrinkTime()
      this.getSystemReminder()
    },
    //判断是否可以使用日历接口，不可以则隐藏日历设置
    allowShowCalendar() {
      //鸿蒙端隐藏日历提醒开关
      if (this.$betterwe.isHarmony()) {
        this.setData[1].hide = true
        return
      }
      Calendar.allowCalendar()
        .then(() => {
          this.setData[1].hide = false
          this.bindCheckCalendar()
        })
        .catch(() => {})
    },
    bindClick() {
      this.showEdit = true
    },
    bindNextTip() {
      this.curTutorial++
      if (this.tipsStepList[this.curTutorial]) {
        this.tipsOptions = this.tipsStepList[this.curTutorial]
      } else {
        this.showTutorial = false
      }
    },
    getShowTutorial() {
      if (!localStorage.getItem('drink-tutorial-set-2')) {
        localStorage.setItem('drink-tutorial-set-2', true)
        this.tipsOptions = this.tipsStepList[0]
        this.showTutorial = true
      }
    },
    toggleCheckbox(item) {
      if (item.toggle && typeof this[item.toggle] == 'function') {
        this[item.toggle](item)
      }
    },
    //切换设置
    changeSystemReminder(item) {
      if (item.loading) {
        return
      }
      let params = {
        water_user_id: this.waterId
      }
      let allow = item.allow
      params[item.setId] = +!allow
      item.loading = true
      this.$http
        .postBaseApp('api/v2/WaterRemind/editMessagePush', params)
        .then((res) => {
          res = res.data
          item.loading = false
          if (res.code == 200) {
            item.allow = !allow
          } else {
            item.allow = allow
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          item.loading = false
        })
        .finally(() => {})
    },
    changeCalendarReminder(item) {
      if (item.loading) {
        return
      }
      item.loading = true
      if (item.allow) {
        this.bindDelCalendar(item)
      } else {
        this.bindSetCalendar(item, this.userInfo.list)
      }
    },
    //停止开关组件加载
    stopSwitchLoading(item, tip) {
      setTimeout(() => {
        this.$toast(tip)
        item.loading = false
      }, 3000)
    },
    //检查本地日历是否存在
    bindCheckCalendar() {
      if (this.setData.length < 2) {
        return
      }
      Calendar.getCalendarList()
        .then((res) => {
          let list = res.data
          if (list && Array.isArray(list)) {
            let hasCalendar = false
            let calendarId
            for (let i = 0; i < list.length; i++) {
              if (list[i].name == Calendar.calendarName) {
                hasCalendar = true
                calendarId = list[i].id
                break
              }
            }
            this.setData[1].allow = hasCalendar
            this.setData[1].value = calendarId
          }
        })
        .catch((err) => {})
        .finally((res) => {
          this.setData[1].loaded = true
        })
    },
    //设置本地日历
    bindSetCalendar(item, timeList) {
      Calendar.bindSetCalendar(timeList)
        .then((res) => {
          item.allow = true
          this.stopSwitchLoading(item, '开启成功')
        })
        .catch((res) => {
          item.allow = false
          this.stopSwitchLoading(item, (res && res.message) || '开启失败')
        })
    },
    //删除本地日历
    bindDelCalendar(item) {
      Calendar.delCalendar()
        .then((res) => {
          item.allow = false
          this.stopSwitchLoading(item, (res && res.message) || '关闭成功')
        })
        .catch((res) => {
          item.allow = true
          this.stopSwitchLoading(item, (res && res.message) || '关闭失败')
        })
    },
    //获取系统提醒
    getSystemReminder() {
      this.$http
        .postBaseApp('api/v2/WaterRemind/getMessageState', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data.generic_is_open_system !== undefined) {
              this.setData[0].allow = !!res.data.generic_is_open_system
              this.setData[0].loaded = true
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    bindConfirm(val) {
      console.log(val)
      this.showEdit = false
      this.curTime = val
      if (!this.checkTime(val, this.userInfo.list)) {
        this.$toast('第一次喝水时间必须早于第二次半小时')
        return
      }
      this.setDrinkTime(val)
    },
    //检查第一次喝水设置时间是否大于等于30分钟
    checkTime(val, list) {
      let time = 30
      if (!list[1].time_slot) {
        //列表少于两个则忽略
        return true
      }
      let secondArr = list[1].time_slot.split(':')
      let secondTime = parseInt(secondArr[0]) * 60 + parseInt(secondArr[1]) //第二次喝水距离凌晨的分钟数
      let shouldTime = secondTime - time //第一次喝水打卡不能超过的凌晨分钟数
      let firstArr = val.split(':')
      let firstTime = parseInt(firstArr[0]) * 60 + parseInt(firstArr[1]) //用户设置的第一次喝水距离凌晨的分钟数
      if (shouldTime - firstTime >= 0) {
        return true
      }
      return false
    },
    bindCancel() {
      this.showEdit = false
    },
    setUserAllow() {
      this.allow = !this.allow
    },
    bindChangePlan() {
      this.$router.push({
        path: '/drink-water-reminder/fill',
        query: {
          change: true
        }
      })
    },
    bindConfirm() {},
    //切换为彩虹杯
    bindChangeCup() {
      let options = {
        showCancelButton: true,
        title: '是否切换为彩虹杯?'
      }
      this.bindConfirm = () => {
        this.switchCupType()
        //this.init();
      }
      this.showMyToast(options)
    },
    //切换彩虹杯类型
    switchCupType() {
      let params = {
        use_version: 1
      }
      this.$http
        .postBaseApp('api/v2/WaterRemind/changeWaterVersion', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$store.commit('drinkWater/setNeedUpdate', true)
            switchCalendar(this.userInfo.list, false)
            this.$router.go(-1)
          } else {
            this.$router.replace({
              path: '/drink-water-reminder/start',
              query: {
                from: 'normalSet'
              }
            })
            this.$toast(res.msg)
          }
        })
    },
    //获取推送消息
    getNoticeSet() {},
    setDrinkTime(time) {
      let params = {
        time_slot: time,
        record_id: this.recordId
      }
      this.$http
        .postBaseApp('member/WaterClock/editWaterPlanRecord', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userInfo.list[0].time_slot = time
            let options = {
              title: '修改成功！',
              message:
                '新的起始时间将从明日生效，<br/>一起好好喝水，好好变美吧！'
            }
            this.showMyToast(options)
            this.resetCalendar(time)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    //根据新设置的时间重新设置日历提醒时间
    resetCalendar(time) {
      //如果用户并没有开启日历通知时修改喝水提醒时间则跳过开启
      if (!this.setData[1].allow) {
        return
      }
      let arr = this.userInfo.list.map((item, index) => {
        let obj = {}
        if (index == 0) {
          obj.time_slot = time
        } else {
          obj.time_slot = item.time_slot
        }
        return obj
      })

      this.bindSetCalendar(this.setData[1], arr)
    },
    showMyToast(options) {
      this.toastOptions = options //信息弹框的数据参数
      this.showToast = true
    },
    hideMyToast() {
      this.showToast = false
    },
    getDrinkTime() {
      let params = {
        water_user_id: this.waterId
      }
      this.$http
        .getBaseApp('api/v2/WaterRemind/getGenericWaterPlan', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.list = this.dealData(res.data.list)
            this.userInfo = res.data
            this.recordId = res.data.list[0].id
            setTimeout(() => {
              this.getShowTutorial()
            }, 500)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loaded = true
        })
    },
    dealData(list) {
      list.map((item) => {
        if (item.water_color == 'rgba(0,0,0,0)') {
          item.water_color = 'rgba(153,153,153,0.6)'
        }
      })
      return list
    }
  }
}
</script>
<style lang="scss" scoped>
.set {
  min-height: 100vh;
  background: #f9f9f9;
  padding: 15px 20px;
  box-sizing: border-box;

  .set-list {
    background-color: #fff;
    border-radius: 12px;
    padding: 0px 20px;
    margin-bottom: 16px;
    box-sizing: border-box;

    .set-item {
      padding: 11px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      .item-left {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
      }
    }

    .set-item:last-child {
      border-bottom: none;
    }
  }

  .time-list {
    background: #ffffff;
    border-radius: 12px;
    padding: 23px 20px;
    box-sizing: border-box;
    margin-bottom: 16px;

    .time-title {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
      margin-bottom: 20px;
    }

    .time-item {
      height: 52px;
      display: flex;
      align-items: center;
      padding: 10px 16px;
      box-sizing: border-box;
      background: #f9f9f9;

      .item-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin-right: 10px;
        display: flex;
        align-items: center;

        .clock {
          margin-right: 8px;
          color: #888;
        }

        .time {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.6);
          line-height: 20px;
          margin-right: 8px;
        }

        .edit {
          font-size: 20px;
          color: #888;
        }
      }
    }

    .time-item:nth-child(2n + 1) {
      background: #fff;
      border-radius: 8px;
    }

    .item-right {
      display: flex;
      align-items: center;

      .color {
        width: 16px;
        height: 4px;
        margin-right: 8px;
      }

      .water-droplet {
        width: 12px;
        height: 18px;
        object-fit: contain;
        margin-right: 12px;
      }

      .ml {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 20px;
        color: #ad96ff;
      }
    }
  }

  .replace-content {
    display: flex;
    padding: 13px 20px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 12px;

    .item-left {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
    }

    .item-right {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 17px;
      display: flex;
      align-items: center;

      .btn {
        margin-left: 8px;
        width: 16px;
        height: 16px;
        border: 1px solid #f1f1f1;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.tips {
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 17px;
  margin-bottom: 20px;
}

.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}
</style>
